import { render } from "./MentorItem.vue?vue&type=template&id=714b4466&scoped=true"
import script from "./MentorItem.vue?vue&type=script&lang=js"
export * from "./MentorItem.vue?vue&type=script&lang=js"

import "./MentorItem.vue?vue&type=style&index=0&id=714b4466&scoped=true&lang=css"

import exportComponent from "/Users/jj_mac/Documents/find-a-mentor-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714b4466"]])

export default __exports__